export default "__VITE_ASSET__BBUCBWqN__"